import { render, staticRenderFns } from "./DataImportExogena.vue?vue&type=template&id=56d86cb6&scoped=true"
import script from "./DataImportExogena.vue?vue&type=script&lang=js"
export * from "./DataImportExogena.vue?vue&type=script&lang=js"
import style0 from "./DataImportExogena.vue?vue&type=style&index=0&id=56d86cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d86cb6",
  null
  
)

export default component.exports